// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2ptxt","upload":"Small_upload__2IDVJ","imageWrap":"Small_imageWrap__2qzmF","removeBtn":"Small_removeBtn__3OE0Y"};